"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lengthSquared = void 0;
/**
 * Returns the squared length of the given 2-vector.
 * @param p a vector
 */
function lengthSquared(v) {
    return v[0] * v[0] + v[1] * v[1];
}
exports.lengthSquared = lengthSquared;
//# sourceMappingURL=length-squared.js.map